export default __webpack_public_path__ + "static/media/login-side-image.41f29ae9.png";